import { Component } from '@angular/core';

@Component({
    selector   : 'cowtux-demo-content',
    templateUrl: './demo-content.component.html',
    styleUrls  : ['./demo-content.component.scss']
})
export class COWTUXDemoContentComponent
{
    /**
     * Constructor
     */
    constructor()
    {
    }
}
